import { render, staticRenderFns } from "./PriceRenderer.vue?vue&type=template&id=e7c35254"
import script from "./PriceRenderer.vue?vue&type=script&setup=true&lang=js"
export * from "./PriceRenderer.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PriceRenderer.vue?vue&type=style&index=0&id=e7c35254&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports